import {useEffect, useState} from 'react';
import ActionModal from 'components/ActionModal';
import ButtonBigWithAction from 'elements/ButtonBigWithAction';
import DeleteRequest from 'components/DeleteRequest'
import LoadingIndicator from 'pages/LoadingIndicator';

const CancelInvoice = ({isOpen, isOpenAction, updateStatus, updatedAction, selectedData}) => {
    const [invoice, setInvoice] = useState({invoiceNo: null, id: null})
    useEffect(() => {
        if(selectedData) {
            setInvoice({invoiceNo: selectedData.invoiceNo, id: selectedData.id})           
        } else {
            setInvoice({invoiceNo: null, id: null})
        }
    }, [selectedData])

    const [cancelStatus, setCancelStatus] = useState(null)
    const [loading, setLoading] = useState(false)

    const handleCancel = (data) => {
        setLoading(true)
        DeleteRequest('api/invoices/'+invoice.id)
            .then(response => {
                const successMessage = (
                    <div className='text-sm text-green-100 bg-green-600 text-bold mb-2 p-1'>
                        <p>Fatura başarıyla iptal edildi. İptal edilen faturalarınıza "İptal Faturalar" üzerinden ulaşabilirsiniz.</p> 
                    </div>
                )
                setCancelStatus(successMessage)
                setLoading(false)
                updatedAction(!updateStatus)
            })
            .catch(error => {
                const err = error.response.data.errors
                if(err) {
                    const errorItems = Object.keys(err).map((value, index) => {
                        return (
                            <li key={value.toString()}>{err[value][0]}</li>
                        )
                    })
                    const errorMessage = (
                        <div className='text-sm text-red-600'>
                            <p>{error.response.data.message}</p>   
                            <ul className='list-[circle] list-inside'>
                                {errorItems}
                            </ul>                     
                        </div>
                    )

                    setCancelStatus(errorMessage)
                } else if(error.response?.data?.ErrorStatus) {
                    if(error.response.data.ErrorStatus?.data) {
                      const errorMessage = (
                        <div className='text-sm text-gray-700 text-bold mb-2 p-1'>
                            <p>{`${error.response.data.ErrorStatus.Message}-${error.response.data.ErrorStatus.data} (${error.response.data.ErrorStatus.Code})`}</p> 
                        </div>
                      )
                      setCancelStatus(errorMessage)
                    } else {
                      const errorMessage = (
                        <div className='text-sm text-gray-700 text-bold mb-2 p-1'>
                            <p>{`${error.response.data.ErrorStatus.Message} (${error.response.data.ErrorStatus.Code})`}</p> 
                        </div>
                      )
                      setCancelStatus(errorMessage)
                    } 
                    
                }  else {
                  const errorMessage = (
                      <div className='text-sm text-gray-700 text-bold mb-2 p-1'>
                          <p>{`${error.response.statusText} (${error.response.status})`}</p> 
                      </div>
                  )  
                  setCancelStatus(errorMessage)
                }             
                
                setLoading(false)
            })
    }

    const actions = (
        <>
            {!cancelStatus && <ButtonBigWithAction type="button" addClass="text-white bg-emerald-500" title="İptal Et" onClick={handleCancel}/>}
        </>
    )

    return (
        <ActionModal isOpen={isOpen} 
                    isOpenAction={isOpenAction} 
                    id="invoiceCancelModal" 
                    title="Faturayı İptal Et" 
                    cancelButton={true} 
                    actions={actions}
                    actionsForClear={[setCancelStatus]}>
            <div>
                {cancelStatus}
            </div>
            <div className=''>                
                {!cancelStatus && <p className='text-md text-gray-700'><span className='font-semibold underline'>{invoice.invoiceNo}</span> nolu faturayı iptal etmek istediğinize emin misiniz?</p>}
            </div>
            {loading && <LoadingIndicator />}
        </ActionModal>
    );
};

export default CancelInvoice;
